import { Dictionary } from "lodash";

export interface ISharedDefinitions {
    applicationInstance: Dictionary<DefinitionApplicationInstance>;
    applicationGroup: Dictionary<DefinitionApplicationGroup>;
    applicationRole: Dictionary<DefinitionApplicationRole>;
    jobTitleCategory: Dictionary<DefinitionJobTitleCategory>;
    product: Dictionary<DefinitionProduct>;
    resourceType: Dictionary<DefinitionResourceType>;
    tag: Dictionary<DefinitionTag>;
}

export interface SharedDefinitionEntry {
    id: number;
    name: string;
}

export interface SharedDefinitionEntryWithCode extends SharedDefinitionEntry {
    code: string;
}

export interface DefinitionApplicationInstance extends SharedDefinitionEntryWithCode {
    description: string;
}

export interface DefinitionJobTitleCategory extends SharedDefinitionEntryWithCode {}

export const EXCLUDED_JOB_TITLE_CATEGORY_CODES = ["Unknown", "Internal"];
export const JOB_TITLE_CATEGORY_OTHER = "Other";

export interface DefinitionProduct extends SharedDefinitionEntryWithCode {
    provider: string;
    description: string;
    parentCode: string;
}

export interface DefinitionApplicationGroup extends SharedDefinitionEntryWithCode {}

export interface DefinitionApplicationRole extends SharedDefinitionEntryWithCode {
    description: string;
    isSspEditable: boolean;
}

export interface DefinitionResourceType extends SharedDefinitionEntryWithCode {}

export interface DefinitionResourceTypeData {
    id: number;
    displayName: string;
    code: string;
}

export interface DefinitionTag extends SharedDefinitionEntryWithCode {
    description: string;
    sspEditable: boolean;
}
